"use client"

import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { uuid } from "@/utils";

const Pricing = () => {
  const intl = useIntl();

  return (
    <section id="pricing" className="relative z-10 pt-[110px]">
      <div className="container">
        <div className="wow fadeInUp mx-auto mb-10 max-w-[690px] text-center" data-wow-delay=".2s">
          <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
            <FormattedMessage
              id="home-page-pricing-title"
              values={{
                span: (...chunks) => (
                  <span
                    key={uuid()}
                    className="inline text-transparent bg-gradient-1 bg-clip-text"
                  >
                    {React.Children.toArray(chunks)}
                  </span>
                )
              }}
            />
          </h2>
          <p className="text-base text-body">
            <FormattedMessage
              id="home-page-pricing-description"
            />
          </p>
        </div>
      </div>

      <div className="container max-w-[1120px] overflow-hidden">
        <div className="flex flex-wrap justify-center -mx-6">
          <div className="w-full px-6 md:w-1/2 lg:w-1/3">
            <div className="py-10 mb-10 bg-white wow fadeInUp rounded-xl px-9 shadow-card dark:bg-dark dark:shadow-card-dark lg:mb-4 lg:px-7 xl:px-9" data-wow-delay=".2s">
              <h3 className="mb-2 text-[22px] font-semibold leading-tight text-black dark:text-white">
                <FormattedMessage
                  id="home-page-pricing-free-pack-name"
                />
              </h3>
              <p className="text-base mb-7 text-body">
                <FormattedMessage
                  id="home-page-pricing-free-pack-sub-title"
                />
              </p>

              <p className="pb-5 text-black border-b border-stroke dark:border-stroke-dark dark:text-white">
                <span className="text-[40px] font-bold leading-none">
                  <sup className="text-[22px] font-bold"> $ </sup>
                  0
                </span>
                <span className="text-base text-body">
                  /
                  <FormattedMessage
                    id="home-page-pricing-free-pack-cycle"
                  />
                </span>
              </p>

              <div className="space-y-4 pt-[30px] pb-10">
                {(intl.messages["home-page-pricing-free-features"])?.map((text, index) => (
                  <p
                    key={index}
                    className="flex text-base text-black dark:text-body"
                  >
                    <span className="mr-[10px] mt-1">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_44_7)">
                          <path d="M6.66674 10.1147L12.7947 3.98599L13.7381 4.92866L6.66674 12L2.42407 7.75733L3.36674 6.81466L6.66674 10.1147Z" fill="#f55c00" />
                        </g>
                        <defs>
                          <clipPath id="clip0_44_7">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    {text}
                  </p>
                ))}

              </div>

              <a
                href="/create-profile"
                alt="Link to create a Downfor link in Bio Page"
                title="Link to create a Downfor link in Bio Page"
                className="block w-full rounded-md bg-black py-[10px] px-8 text-center text-base font-bold text-white hover:bg-primary dark:bg-[#2A2E44] dark:hover:bg-primary"
              >
                <FormattedMessage
                  id="home-page-pricing-signup-button"
                />
              </a>
            </div>
          </div>

          <div className="w-full px-6 md:w-1/2 lg:w-1/3">
            <div className="relative py-10 mb-10 bg-primary/5 wow fadeInUp rounded-xl px-9 shadow-card dark:bg-dark dark:shadow-card-dark lg:mb-4 lg:px-7 xl:px-9" data-wow-delay=".3s">
              <span className="absolute text-sm font-bold underline top-5 right-5 text-primary">
                <FormattedMessage
                  id="home-page-pricing-monthly-extra-name"
                />
              </span>
              <h3 className="mb-2 text-[22px] font-semibold leading-tight text-black dark:text-white">
                <FormattedMessage
                  id="home-page-pricing-monthly-pack-name"
                />
              </h3>
              <p className="text-base mb-7 text-body">
                <FormattedMessage
                  id="home-page-pricing-monthly-pack-sub-title"
                />
              </p>

              <p className="pb-5 text-black border-b border-stroke dark:border-stroke-dark dark:text-white">
                <span className="text-[40px] font-bold leading-none">
                  <sup className="text-[22px] font-bold"> $ </sup>
                  1.99
                </span>
                <span className="text-base text-body">
                  /
                  <FormattedMessage
                    id="home-page-pricing-monthly-pack-cycle"
                  />
                </span>
              </p>

              <div className="space-y-4 pt-[30px] pb-10">
                {(intl.messages["home-page-pricing-monthly-features"])?.map((text, index) => (
                  <p
                    key={index}
                    className="flex text-base text-black dark:text-body"
                  >
                    <span className="mr-[10px] mt-1">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_44_7)">
                          <path d="M6.66674 10.1147L12.7947 3.98599L13.7381 4.92866L6.66674 12L2.42407 7.75733L3.36674 6.81466L6.66674 10.1147Z" fill="#f55c00" />
                        </g>
                        <defs>
                          <clipPath id="clip0_44_7">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    {text}
                  </p>
                ))}
              </div>

              <a
                href="/create-profile"
                alt="Link to create a Downfor link in Bio Page"
                title="Link to create a Downfor link in Bio Page"
                className="block w-full rounded-md bg-primary py-[10px] px-8 text-center text-base font-bold text-white hover:bg-primary/90"
              >
                <FormattedMessage
                  id="home-page-pricing-signup-button"
                />
              </a>
            </div>
          </div>

          <div className="w-full px-6 md:w-1/2 lg:w-1/3">
            <div className="relative py-10 mb-10 bg-white wow fadeInUp rounded-xl px-9 shadow-card dark:bg-dark dark:shadow-card-dark lg:mb-4 lg:px-7 xl:px-9" data-wow-delay=".3s">
              <h3 className="mb-2 text-[22px] font-semibold leading-tight text-black dark:text-white">
                <FormattedMessage
                  id="home-page-pricing-yearly-pack-name"
                />
              </h3>
              <p className="text-base mb-7 text-body">
                <FormattedMessage
                  id="home-page-pricing-yearly-pack-sub-title"
                />
              </p>

              <p className="pb-5 text-black border-b border-stroke dark:border-stroke-dark dark:text-white">
                <span className="text-[40px] font-bold leading-none">
                  <sup className="text-[22px] font-bold"> $ </sup>
                  21.99
                </span>
                <span className="text-base text-body">
                  /
                  <FormattedMessage
                    id="home-page-pricing-yearly-pack-cycle"
                  />
                </span>
              </p>

              <div className="space-y-4 pt-[30px] pb-10">
                {(intl.messages["home-page-pricing-monthly-features"])?.map((text, index) => (
                  <p
                    key={index}
                    className="flex text-base text-black dark:text-body"
                  >
                    <span className="mr-[10px] mt-1">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_44_7)">
                          <path d="M6.66674 10.1147L12.7947 3.98599L13.7381 4.92866L6.66674 12L2.42407 7.75733L3.36674 6.81466L6.66674 10.1147Z" fill="#f55c00" />
                        </g>
                        <defs>
                          <clipPath id="clip0_44_7">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    {text}
                  </p>
                ))}
              </div>

              <a
                href="/create-profile"
                alt="Link to create a Downfor link in Bio Page"
                title="Link to create a Downfor link in Bio Page"
                className="block w-full rounded-md bg-primary py-[10px] px-8 text-center text-base font-bold text-white hover:bg-primary/90"
              >
                <FormattedMessage
                  id="home-page-pricing-signup-button"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;